import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { resolveCtaUrl } from "../../lib/cta";

export default function StickyCta({ data, content }) {
  const [visible, setVisible] = useState(false);
  const threshold = data.showAfterPx || 800;

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > threshold);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);

  if (!visible) return null;

  const href = resolveCtaUrl(content);
  return (
    <div
      data-testid="sticky-cta"
      className="fixed bottom-0 left-0 right-0 z-40 bg-onyx text-alabaster border-t border-gold/30 shadow-2xl animate-in slide-in-from-bottom duration-300"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
        <p className="text-xs sm:text-sm font-medium truncate">{data.text}</p>
        <a
          href={href}
          target="_blank"
          rel="noreferrer"
          data-testid="sticky-cta-button"
          className="flex-shrink-0 inline-flex items-center gap-2 px-4 sm:px-6 py-2.5 bg-gold text-onyx text-[10px] sm:text-xs tracking-[0.2em] uppercase font-semibold hover:bg-alabaster transition-colors whitespace-nowrap"
        >
          {data.ctaLabel}
          <ArrowRight size={14} />
        </a>
      </div>
    </div>
  );
}
